import { useEffect, useRef, useState } from "react";
// import { TileLayer } from "leaflet";
// import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { useDispatch } from "react-redux";
import { dmd_utils } from "../utils/frfr-dmd-utils";
import { json_utils } from "../utils/frfr-json-utils";
import { rapidozi_dummy_utils, rapidozi_dummysmarty_utils, smartydummy_backend_special_instance } from "../utils/frfr-rapidozi-dummy-utils";
import { _zzyourmap_ajax } from "../utils/zz/zz-yourmap-ajax-adapter";
import UniBtn, { UniBtnPack } from "./UniBtn";
import UniSpinnerClassic from "./UniSpinnerClassic";
import UniBreadcrumbs from "./UniBreadcrumbs";
import UniLimiter from "./UniLimiter";
import FrfrAlienGoogleMapsIframe from "./FrfrAlienGoogleMapsIframe";
import FrfrAlienOpenStreetMapIframe from "./FrfrAlienOpenStreetMapIframe";
import { pagination_utils } from "../utils/frfr-pagination-utils";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { geo_utils } from "../utils/frfr-geo-utils";
import { rapidozi_contact_utils } from "../utils/frfr-rapidozi-contact-utils";
import FrfrAlienGoogleMapsIframeBySrc from "./FrfrAlienGoogleMapsIframeBySrc";
import { YourmapAdminPanel } from "./YourmapAdminPanel";
import YourmapMapStandalonePage from "./YourmapMapStandalonePage";
import FrfrAlienEditorjsRendererV1 from "./FrfrAlienEditorjsRendererV1";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import { _zzyourmap_extract_editorjs_renderable_data } from "../utils/zz/zz-yourmap-blog-post-utils";
import { yourmapNavMaker, _zzyourmap_routing_browser_title_update, _zzyourmap_routing_routeState_to_path, _zzyourmap_routing_static_pages_keys, _zzyourmap_routing_tab_keys } from "../utils/zz/zz-yourmap-routing";
import { viarouter69_create_v3b } from "../utils/frfr-viarouter69-temp-v3";
import { _zzyourmap_config } from "../utils/zz/zz-yourmap-config";
import UniPair from "./UniPair";
import UniLink from "./UniLink";
import YourmapSectionHomeStuff from "./YourmapSectionHomeStuff";
import YourmapSectionStaticPageStuff from "./YourmapSectionStaticPageStuff";
import YourmapSectionSmestajStuff from "./YourmapSectionSmestajStuff";
import YourmapSectionOstaloV1Stuff from "./YourmapSectionOstaloV1Stuff";
import YourmapSectionDestionationList from "./YourmapSectionDestionationList";
import YourmapSectionYmthingList from "./YourmapSectionYmthingList";
import YourmapSectionOstaloV1List from "./YourmapSectionOstaloV1List";


//
const MenuOption = (props) => {
  const lang = props.lang;
  const [expanded, setExpanded] = useState(false);

  const handleClickExpanded = (e) => {
    e.stopPropagation();
    console.log('klik*****');
    if (expanded) {
      setExpanded(false);
    } else {
      setExpanded(true);
    }
  };


  // const routeSimple = useSelector(state => state.routeSimple);
  const item = props.item;

  // props.level je level ove opcije u meniju
  const childrenLevel = item.level + 1;

  // const childrenOptions = get_children_routes(item.route, childrenLevel);
  const childrenOptions = [];
  // console.log(childrenOptions);

  const _handleClickOption = props._handleClickOption;

  let jsxTriangle = null;
  if (item.hasChildren === true) {
    /*
    jsxTriangle = (
      <>
        &nbsp;<IconFa fa="fa fa-caret-down" handleClick={handleClickExpanded} />
      </>
    );
    */
  }

  // className={route === item.route ? "option active" : "option"}
  let cl = "option";
  /*
  if (routeSimple === item.route) {
    cl += " active";
  }
  */
  if (expanded) {
    cl += " expanded";
  }

  let href = '';
  if (item.slug_multilang && item.slug_multilang[lang]) {
    href = item.slug_multilang[lang];
  }

  return (
    <a
      className={cl}
      href={href}
      onClick_EX={(e) => { e.preventDefault(); e.stopPropagation(); _handleClickOption(item.route, item.payload) }}
      onClick={props._handleClickOption_navigate}
      data-menu-route={item.route}
    >{item.title}{jsxTriangle}

      {/*
      <div className="submenu">

        
        {childrenOptions.map((item, index) => {
          return (
            <MenuOption
              key={index}
              level={1}
              item={item}
              _handleClickOption={_handleClickOption}
            />
          );
        })}

      </div>
      */}

    </a>
  );
};


//
const MenuOptionList = (props) => {
  // const dispatch = useDispatch();
  const viarouterNavigate = props.viarouterNavigate;
  // const routeSimple = useSelector(state => state.routeSimple );
  // const lang = useSelector(state => state.lang);
  const lang = null;

  const [level1Options, setLevel1Options] = useState([
    {
      title: 'Početna',
      route: 'ROOT_HOME',
      handleClick: (e) => {
        e.preventDefault();
        viarouterNavigate(yourmapNavMaker.ROOT_HOME());
      }
    },
    {
      title: 'Destinacije',
      route: 'ROOT_DESTINATION_LIST',
      handleClick: (e) => {
        e.preventDefault();
        viarouterNavigate(yourmapNavMaker.ROOT_DESTINATION_LIST());
      }
    },
    {
      title: 'Kontakt',
      route: 'ROOT_STATIC_PAGE',
      payload: 'kontakt',
      handleClick: (e) => {
        e.preventDefault();
        viarouterNavigate(yourmapNavMaker.static_page('/kontakt'));
      }
    },
    {
      title: 'O nama',
      route: 'ROOT_STATIC_PAGE',
      payload: 'o-nama',
      handleClick: (e) => {
        e.preventDefault();
        viarouterNavigate(yourmapNavMaker.static_page('/o-nama'));
      }
    },
  ]);

  useEffect(() => {
    // setLevel1Options(get_level_1_routes())
  }, []);


  const _handleClickOption = (route) => {
    // dispatch(actionRouteSet(route));
    console.log('_handleClickOption', route);
    if (typeof props.handleClickMenuOption === 'function') {
      props.handleClickMenuOption(route);
    }
  };

  // console.log(level1Options);

  return (
    <>
      {level1Options.map((item, index) => {
        return (
          <MenuOption
            key={index}
            level={1}
            item={item}
            lang={lang}
            _handleClickOption={_handleClickOption}
            _handleClickOption_navigate={item.handleClick}
          />
        );
      })}
    </>
  );
};



// ERROR 404 NOT FOUND PAGE
const YourmapPageNotFound = (props) => {
  const {
  } = props.appPack;
  const layoutPack = props.layoutPack;
  _zzyourmap_routing_browser_title_update(404);
  return (
    <>
      <YourmapHeader appPack={props.appPack} layoutPack={layoutPack} />
      <section className="yourmap__section yourmap__section-breadcrumbs">
        <div className="inner">
          <div className="uu-gap-standalone-1rem"></div>
          <h2 className="uu-text-center">ROUTE NOT FOUND</h2>
        </div>
      </section>
    </>
  );
};


// -----


// ROUTER v1
const YourmapRouterV1 = (props) => {
  const {
    route_root, // ROOT_HOME ROOT_MAP ROOT_DESTINATION_LIST ROOT_DESTINATION_ITEM 
    route_destination_id,
    route_destination_tab,
    route_smestaj_id,
    route_static_page,
    viarouterNavigate,
  } = props.appPack;
  const layoutPack = props.layoutPack;

  let jsx = null;

  if (route_root === 'ROOT_HOME') {
    jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
          jsxHeaderBtn={
            <UniBtn
              inline
              wide
              titleBeforeIcon
              title="Istraži sve destinacije"
              i="fa fa-arrow-right"
              extraClass="yourmap__theme__custom-btn-blue"
              handleClick={(e) => {
                e.preventDefault();
                // setRouteRoot('ROOT_DESTINATION_LIST');
                viarouterNavigate(yourmapNavMaker.ROOT_DESTINATION_LIST());
              }}
              href={yourmapNavMaker.ROOT_DESTINATION_LIST()}
            />
          }
        />
        <div className="yourmap__section">
          <div className="inner">
            <div className="yourmap__article__title-and-subtitle">
              <div className="uu-gap-standalone-1rem"></div>
              <h2>Popularne Destinacije</h2>
              <p>Otkrijte najposećenije lokacije u Srbiji</p>
            </div>
          </div>
        </div>
        <YourmapSectionDestionationList appPack={props.appPack} limit={4} />
        <YourmapSectionHomeStuff appPack={props.appPack} />
      </>
    );
  } else if (route_root === 'ROOT_DESTINATION_LIST') {
    jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
          jsxHeaderBtn={null}
        />
        <div className="uu-gap-standalone-1rem"></div>
        <YourmapSectionDestionationList appPack={props.appPack} />
      </>
    );
  } else if (route_root === 'ROOT_DESTINATION_ITEM') {
    // SUBROUTER
    let jsxSubrouterDestinationTabs = null;
    let is_tab_default = false;
    if (route_destination_tab === null) {
      is_tab_default = true;
    }
    if (is_tab_default || route_destination_tab === 'smestaji') {
      jsxSubrouterDestinationTabs = (
        <>
          <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
            jsxHeaderBtn={
              <UniBtn
                wide
                titleBeforeIcon
                title="Mapa"
                i="fa fa-map-o"
                extraClass="yourmap__theme__custom-btn-orange"
                handleClick={(e) => {
                  e.preventDefault();
                  // handleClick={() => { setRouteRoot('ROOT_MAP', route_destination_id); }}
                  viarouterNavigate(yourmapNavMaker.ROOT_MAP(route_destination_id));
                }}
                href={yourmapNavMaker.ROOT_MAP(route_destination_id)}
              />
            }
          />
          <YourmapSectionTabs appPack={props.appPack} />
          {/*<YourmapSectionRestoranList appPack={props.appPack} />*/}
          <YourmapSectionYmthingList appPack={props.appPack} />
        </>
      );
    } else if (route_destination_tab === 'restorani') {
      jsxSubrouterDestinationTabs = (
        <>
          <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
            jsxHeaderBtn={
              <UniBtn
                wide
                titleBeforeIcon
                title="Mapa"
                i="fa fa-map-o"
                extraClass="yourmap__theme__custom-btn-orange"
                handleClick={(e) => {
                  e.preventDefault();
                  // handleClick={() => { setRouteRoot('ROOT_MAP', route_destination_id); }}
                  viarouterNavigate(yourmapNavMaker.ROOT_MAP(route_destination_id));
                }}
                href={yourmapNavMaker.ROOT_MAP(route_destination_id)}
              />
            }
          />
          <YourmapSectionTabs appPack={props.appPack} />
          {/*<YourmapSectionRestoranList appPack={props.appPack} />*/}
          <YourmapSectionYmthingList appPack={props.appPack} />
        </>
      );
    } else if (route_destination_tab === 'prodavnice') {
      jsxSubrouterDestinationTabs = (
        <>
          <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
            jsxHeaderBtn={
              <UniBtn
                wide
                titleBeforeIcon
                title="Mapa"
                i="fa fa-map-o"
                extraClass="yourmap__theme__custom-btn-orange"
                handleClick={(e) => {
                  e.preventDefault();
                  // handleClick={() => { setRouteRoot('ROOT_MAP', route_destination_id); }}
                  viarouterNavigate(yourmapNavMaker.ROOT_MAP(route_destination_id));
                }}
                href={yourmapNavMaker.ROOT_MAP(route_destination_id)}
              />
            }
          />
          <YourmapSectionTabs appPack={props.appPack} />
          <YourmapSectionYmthingList appPack={props.appPack} />
        </>
      );
    } else if (route_destination_tab === 'aktivnosti') {
      jsxSubrouterDestinationTabs = (
        <>
          <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
            jsxHeaderBtn={
              <UniBtn
                wide
                titleBeforeIcon
                title="Mapa"
                i="fa fa-map-o"
                extraClass="yourmap__theme__custom-btn-orange"
                handleClick={(e) => {
                  e.preventDefault();
                  // handleClick={() => { setRouteRoot('ROOT_MAP', route_destination_id); }}
                  viarouterNavigate(yourmapNavMaker.ROOT_MAP(route_destination_id));
                }}
                href={yourmapNavMaker.ROOT_MAP(route_destination_id)}
              />
            }
          />
          <YourmapSectionTabs appPack={props.appPack} />
          <YourmapSectionYmthingList appPack={props.appPack} />
        </>
      );
    } else if (route_destination_tab === 'servisi') {
      jsxSubrouterDestinationTabs = (
        <>
          <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
            jsxHeaderBtn={
              <UniBtn
                wide
                titleBeforeIcon
                title="Mapa"
                i="fa fa-map-o"
                extraClass="yourmap__theme__custom-btn-orange"
                handleClick={(e) => {
                  e.preventDefault();
                  // handleClick={() => { setRouteRoot('ROOT_MAP', route_destination_id); }}
                  viarouterNavigate(yourmapNavMaker.ROOT_MAP(route_destination_id));
                }}
                href={yourmapNavMaker.ROOT_MAP(route_destination_id)}
              />
            }
          />
          <YourmapSectionTabs appPack={props.appPack} />
          {/*<YourmapSectionRestoranList appPack={props.appPack} />*/}
          {/*<YourmapSectionOstaloV1List ostalo_tab={'SERVISI'} appPack={props.appPack} />*/}
          <YourmapSectionYmthingList appPack={props.appPack} />
        </>
      );
    } else if (route_destination_tab === 'ostalo') {
      jsxSubrouterDestinationTabs = (
        <>
          <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
            jsxHeaderBtn={
              <UniBtn
                wide
                titleBeforeIcon
                title="Mapa"
                i="fa fa-map-o"
                extraClass="yourmap__theme__custom-btn-orange"
                handleClick={(e) => {
                  e.preventDefault();
                  // handleClick={() => { setRouteRoot('ROOT_MAP', route_destination_id); }}
                  viarouterNavigate(yourmapNavMaker.ROOT_MAP(route_destination_id));
                }}
                href={yourmapNavMaker.ROOT_MAP(route_destination_id)}
              />
            }
          />
          <YourmapSectionTabs appPack={props.appPack} />
          <YourmapSectionOstaloV1List ostalo_tab={'OSTALO'} appPack={props.appPack} />
        </>
      );
    }
    jsx = (
      <>
        {jsxSubrouterDestinationTabs}
      </>
    );
  } else if (route_root === 'ROOT_MAP') {
    jsx = (
      <YourmapMapStandalonePage appPack={props.appPack} />
    );
  } else if (route_root === 'ROOT_SMESTAJ_ITEM') {
    jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack} small />
        <div className="uu-gap-standalone-05rem"></div>
        <YourmapSectionBreadcrumbs appPack={props.appPack} />
        <YourmapSectionSmestajStuff appPack={props.appPack} />
      </>
    );
  } else if (route_root === 'ROOT_RESTORAN_ITEM') {
    jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack} small />
        <div className="uu-gap-standalone-05rem"></div>
        <YourmapSectionBreadcrumbs appPack={props.appPack} />
        <YourmapSectionSmestajStuff appPack={props.appPack} />
      </>
    );
  } else if (route_root === 'ROOT_PRODAVNICA_ITEM') {
    jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack} small />
        <div className="uu-gap-standalone-05rem"></div>
        <YourmapSectionBreadcrumbs appPack={props.appPack} />
        <YourmapSectionSmestajStuff appPack={props.appPack} />
      </>
    );
  } else if (route_root === 'ROOT_AKTIVNOST_ITEM') {
    jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack} small />
        <div className="uu-gap-standalone-05rem"></div>
        <YourmapSectionBreadcrumbs appPack={props.appPack} />
        <YourmapSectionSmestajStuff appPack={props.appPack} />
      </>
    );
  } else if (route_root === 'ROOT_SERVIS_ITEM') {
    jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack} small />
        <div className="uu-gap-standalone-05rem"></div>
        <YourmapSectionBreadcrumbs appPack={props.appPack} />
        <YourmapSectionSmestajStuff appPack={props.appPack} />
      </>
    );
  } else if (route_root === 'ROOT_OSTALO_ITEM') {
    jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack} small />
        <div className="uu-gap-standalone-05rem"></div>
        <YourmapSectionBreadcrumbs appPack={props.appPack} />
        <YourmapSectionOstaloV1Stuff appPack={props.appPack} />
      </>
    );
  } else if (route_root === 'ROOT_STATIC_PAGE') {
    jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
          jsxHeaderBtn={null}
        />
        <YourmapSectionStaticPageStuff appPack={props.appPack} />
      </>
    );
  } else { // ROUTE NOT FOUND
    jsx = (
      <YourmapPageNotFound appPack={props.appPack} layoutPack={layoutPack} />
    );
  }

  //
  if (jsx) {
    return (
      <>
        {jsx}
      </>
    );
  }

  return (
    <>
      <p>ROUTE NOT FOUND</p>
    </>
  );
};


// ROUTER v2
const YourmapRouterV2 = (props) => {
  const {
    route_root, // ROOT_HOME ROOT_MAP ROOT_DESTINATION_LIST ROOT_DESTINATION_ITEM 
    route_destination_id,
    route_subdestination_id,
    route_destination_tab,
    route_smestaj_id,
    route_static_page,
    viarouterNavigate,

    viarouter_current_path,
    //
  } = props.appPack;
  const layoutPack = props.layoutPack;
  /*
  const _routeState = {
    route_root,
    route_destination_id,
    route_subdestination_id,
    route_destination_tab,
    route_smestaj_id,
  };
  */
  let jsx3 = null;
  const jsxNotFound = (
    <YourmapPageNotFound appPack={props.appPack} layoutPack={layoutPack} />
  );
  // const path = _zzyourmap_routing_routeState_to_path(_routeState);
  let route_root_v2 = null;
  const path = viarouter_current_path;
  console.log('path', path);
  const router = viarouter69_create_v3b();
  //
  router.addRoute('/', (req, res, next) => { // route_root === 'ROOT_HOME'
    //
    route_root_v2 = 'ROOT_HOME';
    const jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
          jsxHeaderBtn={
            <UniBtn
              inline
              wide
              titleBeforeIcon
              title="Istraži sve destinacije"
              i="fa fa-arrow-right"
              extraClass="yourmap__theme__custom-btn-blue"
              handleClick={(e) => {
                e.preventDefault();
                // setRouteRoot('ROOT_DESTINATION_LIST');
                viarouterNavigate(yourmapNavMaker.ROOT_DESTINATION_LIST());
              }}
              href={yourmapNavMaker.ROOT_DESTINATION_LIST()}
            />
          }
        />
        <div className="yourmap__section">
          <div className="inner">
            <div className="yourmap__article__title-and-subtitle">
              <div className="uu-gap-standalone-1rem"></div>
              <h2>Popularne Destinacije</h2>
              <p>Otkrijte najposećenije lokacije u Srbiji</p>
            </div>
          </div>
        </div>
        <YourmapSectionDestionationList appPack={props.appPack} limit={4} />
        <YourmapSectionHomeStuff appPack={props.appPack} />
      </>
    );
    return jsx;
  });
  //
  router.addRoute('/destinacije', (req, res, next) => { // route_root === 'ROOT_DESTINATION_LIST') {
    route_root_v2 = 'ROOT_DESTINATION_LIST';
    const jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
          jsxHeaderBtn={null}
        />
        <div className="uu-gap-standalone-1rem"></div>
        <YourmapSectionDestionationList appPack={props.appPack} />
      </>
    );
    return jsx;
  });
  //
  // with subrouter tabs lists
  router.addRoute('/istrazi/:slug/:tab/', (req, res, next) => { // route_root === 'ROOT_DESTINATION_ITEM' ***
    route_root_v2 = 'ROOT_DESTINATION_ITEM';
    // const id = req.params.id;
    const slug = req.params.slug;
    const tab = req.params.tab;
    console.log('req', req);
    console.log('tab', tab);
    if (Easy69_v1.is_value_in_array(tab, _zzyourmap_routing_tab_keys) !== true) {
      console.log('ROUTING ERROR: tab NOT EXIST');
      return jsxNotFound;
    }
    // SUBROUTER
    let jsxSubrouterDestinationTabs = null;
    let is_tab_default = false;
    if (route_destination_tab === null) {
      is_tab_default = true;
    }
    // if (is_tab_default || route_destination_tab === 'smestaji') {
    if (true) {
      jsxSubrouterDestinationTabs = (
        <>
          <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
            jsxHeaderBtn={
              <UniBtn
                wide
                titleBeforeIcon
                title="Mapa"
                i="fa fa-map-o"
                extraClass="yourmap__theme__custom-btn-orange"
                handleClick={(e) => {
                  e.preventDefault();
                  // handleClick={() => { setRouteRoot('ROOT_MAP', route_destination_id); }}
                  viarouterNavigate(yourmapNavMaker.ROOT_MAP(route_destination_id));
                }}
                href={yourmapNavMaker.ROOT_MAP(route_destination_id)}
              />
            }
          />
          <YourmapSectionTabs appPack={props.appPack} />
          {/*<YourmapSectionRestoranList appPack={props.appPack} />*/}
          {/*<YourmapSectionYmthingList appPack={props.appPack} />*/}
          {
            tab === 'blog' ? (
              <YourmapSectionOstaloV1List appPack={props.appPack} />
            ) : (
              <YourmapSectionYmthingList appPack={props.appPack} />
            )
          }
        </>
      );
    }
    const jsx = (
      <>
        {jsxSubrouterDestinationTabs}
      </>
    );
    return jsx;
  });
  //
  // with subrouter thing
  router.addRoute('/istrazi/:slug/:tab/:thing_id', (req, res, next) => { // route_root === 'ROOT_SMESTAJ_ITEM'
    route_root_v2 = 'ROOT_SMESTAJ_ITEM';
    // const id = req.id;
    const slug = req.params.slug;
    const tab = req.params.tab;
    const ymthing_id = req.params.ymthing_id;
    console.log('req', req);
    if (Easy69_v1.is_value_in_array(tab, _zzyourmap_routing_tab_keys) !== true) { return jsxNotFound; } // CASE ROUTE NOT FOUND
    // SUBROUTER
    let jsxSubrouterThings = null;
    if (true) {
      jsxSubrouterThings = (
        <>
          <YourmapHeader appPack={props.appPack} layoutPack={layoutPack} small />
          <div className="uu-gap-standalone-05rem"></div>
          <YourmapSectionBreadcrumbs appPack={props.appPack} />
          {/*<YourmapSectionSmestajStuff appPack={props.appPack} />*/}
          {/*<YourmapSectionOstaloV1Stuff appPack={props.appPack} />*/}
          {
            tab === 'blog' ? (
              <YourmapSectionOstaloV1Stuff appPack={props.appPack} />
            ) : (
              <YourmapSectionSmestajStuff appPack={props.appPack} />
            )
          }
        </>
      );
    }
    const jsx = (
      <>
        {jsxSubrouterThings}
      </>
    );
    return jsx;
  });
  //
  router.addRoute('/mapa/:slug', (req, res, next) => { // route_root === 'ROOT_MAP'
    //
    route_root_v2 = 'ROOT_MAP';
    const slug = req.params.slug;
    console.log('req', req);
    const jsx = (
      <YourmapMapStandalonePage appPack={props.appPack} />
    );
    return jsx;
  });
  //
  //
  router.addRoute('/:static_page_key', (req, res, next) => { // route_root === 'ROOT_STATIC_PAGE'
    //
    route_root_v2 = 'ROOT_STATIC_PAGE';
    const static_page_key = req.params.static_page_key;
    console.log('req', req);
    if (Easy69_v1.is_value_in_array(static_page_key, _zzyourmap_routing_static_pages_keys) !== true) { return jsxNotFound; } // CASE ROUTE NOT FOUND
    const jsx = (
      <>
        <YourmapHeader appPack={props.appPack} layoutPack={layoutPack}
          jsxHeaderBtn={
            <UniBtn
              inline
              wide
              titleBeforeIcon
              title="Istraži sve destinacije"
              i="fa fa-arrow-right"
              extraClass="yourmap__theme__custom-btn-blue"
              handleClick={(e) => {
                e.preventDefault();
                // setRouteRoot('ROOT_DESTINATION_LIST');
                viarouterNavigate(yourmapNavMaker.ROOT_DESTINATION_LIST());
              }}
              href={yourmapNavMaker.ROOT_DESTINATION_LIST()}
            />
          }
        />
        <YourmapSectionStaticPageStuff appPack={props.appPack} />
      </>
    );
    return jsx;
  });
  //
  //
  //
  console.log('router', router);
  // router.execute(path);
  /*
  const jsxNotFound = (
    <>{'Ooops :('}</>
  );
  */
  // const jsxNotFound = 'Ooops :(';
  const [returned_value_from_router, status_is_finished_with_succes] = router.execute(path).get_returned_value('Ooops :(');
  const [returned_value_from_router2, status_is_finished_with_succes2] = router.get_returned_value(jsxNotFound);
  console.log('router', router);
  console.log('returned_value_from_router', returned_value_from_router);
  console.log('returned_value_from_router2', returned_value_from_router2);
  console.log('status_is_finished_with_succes2', status_is_finished_with_succes2);
  console.log('route_root_v2', route_root_v2);
  jsx3 = returned_value_from_router2;
  //
  if (jsx3) {
    return (
      <>
        {jsx3}
      </>
    );
  }

  // ---
  return (
    <>
      <p>ROUTE NOT FOUND</p>
    </>
  );
};


// -----


//
const YourmapSectionTabs = (props) => {
  const {
    route_destination_id,
    route_destination_tab,
    // setRouteDestinationTab,
    viarouterNavigate,
  } = props.appPack;
  let is_tab_default = false;
  if (route_destination_tab === null) {
    is_tab_default = true;
  }
  return (
    <>
      <section className="yourmap__section yourmap__section-tabs">
        <div className="inner">
          <div className="uu-vector uu-vector--row uu-vector--center-all">
            <UniBtnPack tabs>
              <UniBtn
                tab
                active={is_tab_default || route_destination_tab === 'smestaji'}
                wide
                title="Smeštaji"
                i="fa fa-bed"
                extraClass="yourmap__theme__custom-btn-tab"
                handleClick={(e) => {
                  e.preventDefault();
                  // setRouteDestinationTab('smestaji');
                  viarouterNavigate(yourmapNavMaker.smestaj_list(route_destination_id));
                }}
                href={yourmapNavMaker.smestaj_list(route_destination_id)}
              />
              <UniBtn
                tab
                active={route_destination_tab === 'restorani'}
                wide
                title="Restorani"
                i="fa fa-cutlery"
                extraClass="yourmap__theme__custom-btn-tab"
                handleClick={(e) => {
                  e.preventDefault();
                  // setRouteDestinationTab('restorani');
                  viarouterNavigate(yourmapNavMaker.restoran_list(route_destination_id));
                }}
                href={yourmapNavMaker.restoran_list(route_destination_id)}
              />
              <UniBtn
                tab
                active={route_destination_tab === 'servisi'}
                wide
                title="Servisi"
                i="fa fa-map-pin"
                extraClass="yourmap__theme__custom-btn-tab"
                handleClick={(e) => {
                  e.preventDefault();
                  // setRouteDestinationTab('servisi');
                  viarouterNavigate(yourmapNavMaker.servis_list(route_destination_id));
                }}
                href={yourmapNavMaker.servis_list(route_destination_id)}
              />
              <UniBtn
                tab
                active={route_destination_tab === 'prodavnice'}
                wide
                title="Prodavnice"
                i="fa fa-shopping-bag"
                extraClass="yourmap__theme__custom-btn-tab"
                handleClick={(e) => {
                  e.preventDefault();
                  // setRouteDestinationTab('servisi');
                  viarouterNavigate(yourmapNavMaker.prodavnica_list(route_destination_id));
                }}
                href={yourmapNavMaker.prodavnica_list(route_destination_id)}
              />
              <UniBtn
                tab
                active={route_destination_tab === 'aktivnosti'}
                wide
                title="Aktivnosti"
                i="fa fa-street-view"
                extraClass="yourmap__theme__custom-btn-tab"
                handleClick={(e) => {
                  e.preventDefault();
                  // setRouteDestinationTab('servisi');
                  viarouterNavigate(yourmapNavMaker.aktivnost_list(route_destination_id));
                }}
                href={yourmapNavMaker.aktivnost_list(route_destination_id)}
              />
              <UniBtn
                tab
                active={route_destination_tab === 'znamenitosti'}
                wide
                title="Znamenitosti"
                i="fa fa-tree"
                extraClass="yourmap__theme__custom-btn-tab"
                handleClick={(e) => {
                  e.preventDefault();
                  // setRouteDestinationTab('servisi');
                  viarouterNavigate(yourmapNavMaker.znamenitost_list(route_destination_id));
                }}
                href={yourmapNavMaker.znamenitost_list(route_destination_id)}
              />
              <UniBtn
                tab
                active={route_destination_tab === 'ostalo'}
                wide
                title="Ostalo"
                i_EX="fa fa-info-circle"
                i="fa fa-sticky-note-o"
                extraClass="yourmap__theme__custom-btn-tab"
                handleClick={(e) => {
                  e.preventDefault();
                  // setRouteDestinationTab('ostalo');
                  viarouterNavigate(yourmapNavMaker.ostalo_list(route_destination_id));
                }}
                href={yourmapNavMaker.ostalo_list(route_destination_id)}
              />
              <UniBtn
                tab
                active={route_destination_tab === 'blog'}
                wide
                title="Blog"
                i="fa fa-info-circle"
                extraClass="yourmap__theme__custom-btn-tab"
                handleClick={(e) => {
                  e.preventDefault();
                  // setRouteDestinationTab('ostalo');
                  viarouterNavigate(yourmapNavMaker.blog_list(route_destination_id));
                }}
                href={yourmapNavMaker.blog_list(route_destination_id)}
              />
            </UniBtnPack>
          </div>
        </div>
      </section>
    </>
  );
};


//
const YourmapSectionBreadcrumbs = (props) => {
  const {
    route_destination_tab,
    setRouteDestinationTab,
    breadcrumbs,
  } = props.appPack;
  let is_tab_default = false;
  if (route_destination_tab === null) {
    is_tab_default = true;
  }
  return (
    <>
      <section className="yourmap__section yourmap__section-breadcrumbs">
        <div className="inner">
          <div>
            <UniBreadcrumbs breadcrumbs={breadcrumbs} />
          </div>
        </div>
      </section>
    </>
  );
};


//
const YourmapHeader = (props) => {
  const {
    route_destination_tab,
    setRouteDestinationTab,
    setRouteRoot,
    viarouterNavigate,
    handleClickHome,
    handleClickMenuOption,
    header_img_url,
  } = props.appPack;
  const {
    handleClickDrawerOpen,
  } = props.layoutPack;
  const jsxHeaderBtn = props.jsxHeaderBtn;
  //
  // const thing_id = item.of_id;
  // const img_url_full = _zzyourmap_img_url_full_from_parts(item.smestaj_main_img_filename, 'uploads');
  const img_url_full = header_img_url;
  const style = {
    // backgroundImage: 'url("https://ymdemo2.applabz.work/uploads/2025-11-30_img_692d2f80c5777.jpg")',
    backgroundImage: 'url("' + img_url_full + '")',
  };
  const logo_url_full = _zzyourmap_config.logo_img_url_full;
  const style_logo = {
    // backgroundImage: 'url("https://ymdemo2.applabz.work/uploads/2025-11-30_img_692d2f80c5777.jpg")',
    backgroundImage: 'url("' + logo_url_full + '")',
  };
  //
  return (
    <>
      <header className={"yourmap__header" + (props.small === true ? " yourmap__header--small" : "")}>
        <div className="drawer-toggle close" onClick={handleClickDrawerOpen}><i className="fa fa-bars" aria-hidden="true"></i></div>
        <div className="yourmap__header__overlay-1" style={style}></div>
        <div className="yourmap__header__overlay-2"></div>
        <div className="inner">
          <div className="yourmap__header__room">

            <div className="yourmap__header__top-bar-vector">
              <div className="logo-container">
                <div className="yourmap__logo-bg logo clickable" onClick={handleClickHome} style={style_logo}></div>
              </div>
              <nav className="yourmap__main-menu">
                <MenuOptionList handleClickMenuOption={handleClickMenuOption} viarouterNavigate={viarouterNavigate} />
                {
                  /*'<MenuOptionList />'*/
                }
              </nav>
            </div>

            <div className="yourmap__header__article">
              <div className="yourmap__article__title-and-subtitle">
                <div className="uu-gap-standalone-1rem"></div>
                <h1>Otkrijte Srbiju kroz naše mape</h1>
                <p>Otkrijte čarobnu planinu koja spaja netaknutu prirodu, bogatu istoriju i gostoprimstvo koje će Vas oduševiti</p>
              </div>
              <div className="">
                {jsxHeaderBtn && (
                  <>{jsxHeaderBtn}</>
                )}
              </div>
            </div>

          </div>
        </div>
      </header>
    </>
  );
};


//
const YourmapFooter = (props) => {
  const {
    route_destination_id,
    setRouteRoot,
    viarouterNavigate,
    handleClickHome,
    destinations_pupular_entities,
  } = props.appPack;
  const logo_url_full = _zzyourmap_config.logo_img_url_full;
  const style_logo = {
    // backgroundImage: 'url("https://ymdemo2.applabz.work/uploads/2025-11-30_img_692d2f80c5777.jpg")',
    backgroundImage: 'url("' + logo_url_full + '")',
  };
  return (
    <>
      <div className="flex-1"></div>
      <footer className="yourmap__footer">
        <div className="inner">
          <div className="yourmap__footer__columns">
            <div className="yourmap__footer__col">
              <div onClick={handleClickHome} className="yourmap__footer__logo-container"><div className="yourmap__logo-bg" style={style_logo}></div></div>

              <p className="yourmap__copyright">Vaš vodič kroz najlepše destinacije Srbije</p>
            </div>
            <div className="yourmap__footer__col">
              <h4>Destinacije</h4>
              {/*
              <a>Kopaonik</a>
              <a>Zlatibor</a>
              <a>Tara</a>
              <a>Đerdap</a>
              */}
              {
                destinations_pupular_entities.map((item, index) => {
                  return (
                    <UniLink
                      key={index}
                      handleClick={(e) => {
                        e.preventDefault();
                        // setRouteRoot('ROOT_DESTINATION_ITEM', item.of_id);
                        viarouterNavigate(yourmapNavMaker.ROOT_DESTINATION_ITEM(item.of_id));
                      }}
                      href={yourmapNavMaker.ROOT_DESTINATION_ITEM(item.of_id)}
                    >{item.destinacija_naslov}</UniLink>
                  );
                })
              }
            </div>
            <div className="yourmap__footer__col">
              <h4>Linkovi</h4>
              <UniLink
                handleClick={(e) => {
                  e.preventDefault();
                  viarouterNavigate(yourmapNavMaker.static_page('/o-nama'));
                }}
                href={yourmapNavMaker.static_page('/o-nama')}
              >O nama</UniLink>
              <UniLink
                handleClick={(e) => {
                  e.preventDefault();
                  viarouterNavigate(yourmapNavMaker.static_page('/kontakt'));
                }}
                href={yourmapNavMaker.static_page('/kontakt')}
              >Kontakt</UniLink>
              <UniLink
                handleClick={(e) => {
                  e.preventDefault();
                  viarouterNavigate(yourmapNavMaker.static_page('/uslovi'));
                }}
                href={yourmapNavMaker.static_page('/uslovi')}
              >Uslovi korišćenja</UniLink>
              <UniLink
                handleClick={(e) => {
                  e.preventDefault();
                  viarouterNavigate(yourmapNavMaker.static_page('/privatnost'));
                }}
                href={yourmapNavMaker.static_page('/privatnost')}
              >Privatnost</UniLink>
            </div>
            <div className="yourmap__footer__col">
              <h4>Pratite nas</h4>
              <p className="yourmap__copyright">© 2026 Yourmap portal. Sva prava zadržana.</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}


//
const YourmapFooterOld = (props) => {
  const {
    handleClickHome,
  } = props.appPack;
  return (
    <footer>
      <div className="inner">


        <div className="footer-contact">
          <div className="footer-logo">
            <div className="logo clickable" onClick={handleClickHome}>LOGO</div>
          </div>
          <div className="contact-items">
            <div className="pair">
              <div className="icon"><i className="fa fa-phone" aria-hidden="true"></i></div>
              <div className="text">
                <a href="tel:+381123456789">
                  <p>+381 12 345 67 89</p>
                </a>
              </div>
            </div>
            <div className="pair">
              <div className="icon"><i className="fa fa-mobile" aria-hidden="true"></i></div>
              <div className="text">
                <a href="tel:+38112345678">
                  <p>+381 12 345 678</p>
                </a>
              </div>
            </div>
            <div className="pair">
              <div className="icon"><i className="fa fa-envelope-o" aria-hidden="true"></i></div>
              <div className="text">
                <a href="mailto:something@email.com">
                  <p>something@email.com</p>
                </a>
              </div>
            </div>
            <div className="pair">
              <div className="icon"><i className="fa fa-map-marker" aria-hidden="true"></i></div>
              <div className="text">
                <a target="_blank" href="https://www.google.com/maps/search/?api=1&query=45.2558866,19.8366624">
                  <p>Adresa Aderesa 1</p>
                  <p>21000 Novi Sad</p>
                  <p>Srbija</p>
                </a>
              </div>
            </div>
            <div className="pair">
              <div className="icon"><i className="fa fa-clock-o" aria-hidden="true"></i></div>
              <div className="text">
                <p>Ponedeljak-Nedelja 08-16h</p>
              </div>
            </div>
          </div>

          <div className="contact-items">
            <div className="pair">
              <div className="icon"><i className="fa fa-facebook-square" aria-hidden="true"></i></div>
              <div className="text">
                <a target="_blank" href="https://www.facebook.com/">
                  <p>Facebook</p>
                </a>
              </div>
            </div>
            <div className="pair">
              <div className="icon"><i className="fa fa-instagram" aria-hidden="true"></i></div>
              <div className="text">
                <a href="#">
                  <p>Instagram</p>
                </a>
              </div>
            </div>
            {/*
          <div className="pair">
            <div className="icon"><i className="fa fa-linkedin" aria-hidden="true"></i></div>
            <div className="text">
              <a href="#">
                <p>LinkedIn</p>
              </a>
            </div>
          </div>
          */}
            <div className="pair">
              <div className="icon"><i className="fa fa-twitter" aria-hidden="true"></i></div>
              <div className="text">
                <a href="#">
                  <p>Twitter</p>
                </a>
              </div>
            </div>
            <div className="pair">
              <div className="icon"><i className="fa youtube-play" aria-hidden="true"></i></div>
              <div className="text">
                <a href="#">
                  <p>YouTube</p>
                </a>
              </div>
            </div>
          </div>

          <div className="contact-items">
            <div className="pair">
              <div className="icon"></div>
              <div className="text">
                <p className="clickable" onClick={() => {
                  // dispatch(actionModalOpen(<span>NESTO</span>)) 
                }}>Test open modal</p>
              </div>
            </div>
          </div>
        </div>


        <p className="copyright">Copyright © 2025 ...yourmap... Sva prava zadržana.</p>
      </div>
    </footer>
  );
}


// DEFAULT COMPONENT
const YourmapLayout = (props) => {
  const {
    route_freshness,
    viarouterNavigate,
    handleClickMenuOption,
  } = props.appPack;

  const detected_env = _zzyourmap_config.ENV_EXTERNAL;

  // const dispatch = useDispatch();
  // const drawer_opened = true;
  // const drawer_opened = useSelector(state => state.drawer_opened);
  const [drawerOpened, setDrawerOpened] = useState(false);
  const drawer_opened = drawerOpened;
  // const lang = useSelector(state => state.lang);

  const handleClickDrawerClose = () => {
    // dispatch(actionDrawerToggle());
    setDrawerOpened(false);
  };
  const handleClickDrawerOpen = () => {
    // dispatch(actionDrawerToggle());
    setDrawerOpened(true);
  };

  useEffect(() => {
    if (drawer_opened) {
      //
      document.body.classList.add("drawer-opened"); // js
    } else {
      document.body.classList.remove("drawer-opened"); // js
    }
  }, [drawer_opened]);

  // TODO
  useEffect(() => { // REFRESH BY ROUTE (or refresh once on mount)
    // refresh();
  }, [route_freshness]);

  const layoutPack = {
    handleClickDrawerOpen,
  };

  return (
    <>
      <div className="yourmap yourmap__wrapper yourmap-theme__scope-public yourmap--debugNOT">
        {
          /*
          <div className="yourmap__env">{detected_env}</div>
          */
        }
        {
          detected_env === 'LOCALHOST' && (
            <div className="yourmap__env">LOCALHOST ENVIRONMENT</div>
          )
        }
        {
          detected_env === 'DEMO' && (
            <div className="yourmap__env">STG ENVIRONMENT FOR TESTING</div>
          )
        }
        {/*
        <YourmapRouterV1 appPack={props.appPack} layoutPack={layoutPack} />
        */}
        <YourmapRouterV2 appPack={props.appPack} layoutPack={layoutPack} />

        <YourmapFooter appPack={props.appPack} layoutPack={layoutPack} />

        {/*
        <YourmapFooterOld appPack={props.appPack} />
        */}

        <YourmapAdminPanel appPack={props.appPack} />

        <div className={drawer_opened ? "drawer opened" : "drawer"}>
          <div className="drawer-toggle close" onClick={handleClickDrawerClose}>&times;</div>
          <nav className="yourmap__main-menu">
            <MenuOptionList handleClickMenuOption={handleClickMenuOption} viarouterNavigate={viarouterNavigate} />
            {
              /*'<MenuOptionList />'*/
            }
          </nav>
        </div>


      </div>
    </>
  );
};

export default YourmapLayout;